import React, { forwardRef } from "react";

import "./Input.css";

const Input = (props, ref) => {
  return (
    <input
      {...props}
      ref={ref}
      type="text"
      className={"input " + (props.className ? props.className : "")}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
    />
  );
};

export default forwardRef(Input);
